module.exports = __webpack_public_path__ + "assets/img/rated.16b254d4.png";